<template>
  <div
    class="arrow-button"
    :class="{
      'arrow-button--rotated-90': rotated90,
      'arrow-button--rotated-180': rotated180,
    }"
    @click="emitClick"
  >
    <svg
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.52433 3.64913L1.0016 0.126462C0.920118 0.0449215 0.811354 0 0.695382 0C0.57941 0 0.470646 0.0449215 0.38917 0.126462L0.129745 0.385823C-0.0390649 0.554826 -0.0390649 0.829503 0.129745 0.998248L3.08787 3.95637L0.126462 6.91778C0.0449859 6.99932 0 7.10802 0 7.22393C0 7.33997 0.0449859 7.44867 0.126462 7.53027L0.385887 7.78957C0.467428 7.87111 0.576128 7.91603 0.6921 7.91603C0.808072 7.91603 0.916836 7.87111 0.998313 7.78957L4.52433 4.26368C4.606 4.18188 4.65086 4.07267 4.6506 3.95657C4.65086 3.84002 4.606 3.73087 4.52433 3.64913Z"
        fill="#666D79"
      />
    </svg>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
export default {
  name: 'ArrowButton',
  props: {
    rotated90: {
      type: Boolean,
      default: false,
    },
    rotated180: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitClick() {
      $emit(this, 'click')
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
.arrow-button {
  max-width: 100%;
  max-height: 100%;
  width: 30px;
  height: 30px;
  border: 1px solid $stroke;
  border-radius: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s linear;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

  &--rotated {
    &-180 {
      svg,
      img {
        transform: rotate(180deg);
      }
    }

    &-90 {
      svg,
      img {
        transform: rotate(90deg);
      }
    }

    svg,
    img {
      transform: rotate(90deg);
    }
  }

  svg,
  img {
    max-width: 100%;
    max-height: 100%;

    transition: transform 0.2s linear;
  }
}
</style>
